import { DocumentoAllegato } from '../../../models/documento-allegato';

export class DocumentoAllegatoAdapter {
  documento: DocumentoAllegato = new DocumentoAllegato();
  constructor(documento: DocumentoAllegato) {
    this.documento.id = documento.id;
    this.documento.titolo = documento.titolo;
    this.documento.provenienza = documento.provenienza;
    this.documento.dataRiferimento = documento.dataRiferimento;
    this.documento.note = documento.note;
    this.documento.autore = documento.autore;
    this.documento.archivio = documento.archivio;
    this.documento.contentType = documento.contentType;
    this.documento.contentSize = documento.contentSize;
    this.documento.dataAggiornamento = documento.dataAggiornamento;
    this.documento.dataCaricamento = documento.dataCaricamento;
    this.documento.nomeFile = documento.nomeFile;
    this.documento.note = documento.note;
    this.documento.posizione = documento.posizione;
    this.documento.tipoDocumento = documento.tipoDocumento;
    this.documento.utenteAggiornamento = documento.utenteAggiornamento;
    this.documento.utenteCreazione = documento.utenteCreazione;
    this.documento.versione = documento.versione;
    this.documento.refDocumentale = documento.refDocumentale;
    this.documento.flagTimbratura = documento.flagTimbratura;
    this.documento.numeroProtocollo = documento.numeroProtocollo;
    this.documento.senderReceiver = documento.senderReceiver;
    this.documento.dataProtocollazione = documento.dataProtocollazione;
    this.documento.utenteProtocollatore = documento.utenteProtocollatore;
    this.documento.oggettoProtocollo = documento.oggettoProtocollo;
    this.documento.protocolDocuments = documento.protocolDocuments;
    this.documento.inUscita = documento.inUscita;
    this.documento.oggettoProtocolloEsteso = documento.oggettoProtocolloEsteso;
    this.documento.primary = documento.primary;
    this.documento.flagAllegatoPrincipale = documento.flagAllegatoPrincipale;
    this.documento.flagOcr = documento.flagOcr;
    this.documento.missingFile = documento.missingFile;
    this.documento.flagAttoPrincipale = documento.flagAttoPrincipale;
    this.documento.statoDocumento = documento.statoDocumento;
    this.documento.estremiProvvedimento = documento.estremiProvvedimento;
    this.documento.dataAnnullamento = documento.dataAnnullamento;
    this.documento.identificativoOperatore = documento.identificativoOperatore;
    this.documento.metadatoFirmaDocumenti = documento.metadatoFirmaDocumenti;
    this.documento.metadatoDocumento = documento.metadatoDocumento
    this.documento.tipoVisibilitaDocumento = documento.tipoVisibilitaDocumento;
    this.documento.classeTitolario = documento.classeTitolario;
    this.documento.algoritmoImprontaDocumento = documento.algoritmoImprontaDocumento;
    this.documento.improntaDocumento = documento.improntaDocumento;
    this.documento.statoConservazione = documento.statoConservazione;
  };
}

